import { Click } from '@lib/iab/iab-vast-model';

interface IClick {
    id: string;
    _value: string;
}

const createClick = ($click: IClick): Click => {
    const click = new Click();
    click.id = $click.id;
    click.uri = $click._value;
    return click;
};

export default createClick;
